export default __webpack_public_path__ + "static/media/breach.8dffb016.svg";